module.exports = __webpack_public_path__ + "img/bold.76ec5dcb.svg";